import PropTypes from 'prop-types';

const studentResultPropType = PropTypes.shape({
    id: PropTypes.number,
    studentName: PropTypes.string,
    totalCorrect: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    topScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    accuracy: PropTypes.string,
    questionsPerMinute: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ])
});

const groupResultPropType = PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    courseName: PropTypes.string,
    studentLiveMathsResults: PropTypes.arrayOf(studentResultPropType)
});

const liveMathsDataPropType = PropTypes.shape({
    id: PropTypes.number,
    level: PropTypes.string,
    groups: PropTypes.arrayOf(groupResultPropType)
});

export default {
    studentResultPropType,
    groupResultPropType,
    liveMathsDataPropType
};



// WEBPACK FOOTER //
// ./containers/live-maths/single-class/single-class-prop-types.js